import { inject, observer } from 'mobx-react';
import { Grid, ITagProps } from 'telia-front-react';
import * as React from 'react';
import config from '../../Config';
import RoamingPackageCard from './RoamingPackageCard';
import { Segment, SEGMENT_PRIVATE } from '../../stores/SegmentStore';
import RoamingStore from '../../stores/RoamingStore';
import LanguageStore from '../../stores/LanguageStore';
import { Country, Package } from '../RoamingInterfaces';
import { TranslationsContext } from '@teliaee/telia-translate';

interface RoamingPackagesProps {
  segment: Segment;
  languageStore?: LanguageStore;
  roamingStore?: RoamingStore;
}

@observer
class RoamingPackages extends React.Component<RoamingPackagesProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;

  private getDayPackageTermsLink() {
    const {
      languageStore: { currentLanguage },
      segment
    } = this.props;
    return segment === SEGMENT_PRIVATE
      ? currentLanguage === 'et'
        ? config.roamingDayPackageTermsB2CEst
        : config.roamingDayPackageTermsB2CRus
      : currentLanguage === 'et'
        ? config.roamingDayPackageTermsB2BEst
        : config.roamingDayPackageTermsB2BRus;
  }

  private getPackageTermsLink(roamingPackage: Package) {
    const { segment } = this.props;
    const translate = this.context.translate;

    return translate(`roaming.country.package.modal.terms.link.${segment}.${roamingPackage.serviceShortName}`, {
      baseUrl: config.teliaWebUrl
    });
  }

  private renderPackageCard(roamingPackage: Package, selectedCountry: Country, packageTag: ITagProps, isDayPackage: boolean = false) {
    const { segment } = this.props;
    return (
      <RoamingPackageCard
        roamingPackage={roamingPackage}
        selectedCountry={selectedCountry}
        segment={segment}
        packageTag={packageTag}
        packageTermsLink={isDayPackage ? this.getDayPackageTermsLink() : this.getPackageTermsLink(roamingPackage)}
        showOrderingModal={!isDayPackage}
      />
    );
  }

  public render() {
    const { roamingStore } = this.props;
    const dayPackage = roamingStore.getPackageByShortName('GDAY', 'DCAP');
    const weekPackage = roamingStore.getPackageByShortName('WEEK');
    const monthPackage = roamingStore.getPackageByShortName('GMOON');
    const selectedCountry = roamingStore.selectedCountry;

    return (
      <Grid equalHeight={true}>
        {dayPackage && this.renderPackageCard(dayPackage, selectedCountry, roamingStore.dailyPackageTag, true)}
        {weekPackage && this.renderPackageCard(weekPackage, selectedCountry, roamingStore.weeklyPackageTag)}
        {monthPackage && this.renderPackageCard(monthPackage, selectedCountry, roamingStore.monthlyPackageTag)}
      </Grid>
    );
  }
}

export default inject('roamingStore', 'languageStore')(RoamingPackages);
